<template>
    <header class="menu">
        <div class="open_responsive">
            <div class="mdi mdi-menu"></div>
        </div>
        <div class="menu_responsive_overlay"></div>
        <nav class="nav">
            <div class="logo_nav">
                <img src="@/assets/img/logito_demo.png" alt="" class="hhead_logo">
                <p class="hhead_iso">chefpolis</p></div>
            <ul>
                <li :class="`menu_item ${isActive('dashboard')? 'current': ''}`" v-if="$can('manage', 'dashboard')">
                    <router-link tag="a" :to="{name:'dashboard'}">
                        <i class="mdi mdi-home"></i>
                        <span>Portada</span>
                    </router-link>
                </li>
                <li class="menu_item" v-if="$can('manage', 'users')">
                    <a href="javascript:void(0)" class="data_acordeon mdi mdi-chevron-down"
                       :class="{'active': isParentActive('user') || isActive('user-creator')}">
                        <i class="mdi mdi-account-key"></i>
                        <span>Usuarios</span>
                    </a>
                    <ul class="submenu" :style="isParentActive('user') || isActive('user-creator') ? 'display:block;': 'display:none;'">
                        <li :class="`${isActive('users')? 'current': ''}`">
                            <router-link tag="a" :to="{name: 'users'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Lista de usuarios</span>
                            </router-link>
                        </li>
                        <li :class="`${isActive('user-creator') ? 'current': ''}`">
                            <router-link tag="a" :to="{name:'user-creator'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Crear usuario</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="menu_item" v-if="$can('manage', 'articles')">
                    <a href="javascript:void(0)" class="data_acordeon mdi mdi-chevron-down"
                       :class="{'active': isParentActive('article') || isActive('article-creator')}">
                        <i class="mdi mdi-package"></i>
                        <span>Entradas</span>
                    </a>
                    <ul class="submenu" :style="isParentActive('article') || isActive('article-creator') ? 'display:block;': 'display:none;'">
                        <li :class="`${isActive('articles')? 'current': ''}`">
                            <router-link tag="a" :to="{name: 'articles'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Lista de entradas</span>
                            </router-link>
                        </li>
                        <li :class="`${isActive('article-creator') ? 'current': ''}`">
                            <router-link tag="a" :to="{name:'article-creator'}"><i class="mdi mdi-circle-medium"></i>
                                <span>Crear entrada</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <div class="collapse">
            <i class="mdi mdi-chevron-left"></i>
        </div>
    </header>
</template>

<script>
    import {Can} from '@casl/vue'

    export default {
        components: {Can},
        data() {
            return {
                categories: [],
                subcategories: []
            }
        },
        methods: {
            isActive(input) {
                const self = this;
                return self.$route.name && self.$route.name === input;
            },
            isParentActive(input) {
                const self = this;
                return self.$route.name && self.$route.name.startsWith(input);
            }
        },
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/Menu.vue